import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { MapPinOff, Check } from "lucide-react";
import { toast } from "sonner";

export function WaitlistForm({ source = "landing", defaultEmail = "", compact = false }) {
  const [open, setOpen] = useState(!compact);
  const [f, setF] = useState({ email: defaultEmail, name: "", city: "", country: "" });
  const [done, setDone] = useState(null);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { setDone((await api.post("/waitlist", { ...f, name: f.name || null, source })).data.message); }
    catch (err) { toast.error(apiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  if (!open) {
    return (
      <button type="button" data-testid="waitlist-open-btn" onClick={() => setOpen(true)} className="text-sm text-amber-300 hover:text-amber-200 underline underline-offset-4 flex items-center gap-1.5">
        <MapPinOff className="h-4 w-4" /> I'm not near Clapham
      </button>
    );
  }
  if (done) return <p data-testid="waitlist-success" className="text-sm text-emerald-300 flex items-center gap-2"><Check className="h-4 w-4" /> {done}</p>;
  return (
    <form onSubmit={submit} data-testid="waitlist-form" className="glass rounded-2xl p-4 space-y-2 text-left">
      <p className="text-sm font-semibold flex items-center gap-1.5"><MapPinOff className="h-4 w-4 text-amber-300" /> Not near Clapham? Join the waitlist</p>
      <p className="text-xs text-slate-400">We're live in Clapham, London first. Tell us where you are and we'll email you when we launch there.</p>
      <div className="grid grid-cols-2 gap-2">
        {[["email", "Email", "email"], ["name", "First name (optional)", "text"], ["city", "Your city", "text"], ["country", "Country", "text"]].map(([k, ph, type]) => (
          <input key={k} data-testid={`waitlist-${k}`} type={type} required={k !== "name"} value={f[k]} placeholder={ph} maxLength={60}
            onChange={(e) => setF({ ...f, [k]: e.target.value })}
            className="h-10 rounded-xl bg-white/5 border border-white/10 px-3 text-sm outline-none focus:border-amber-400/40 min-w-0" />
        ))}
      </div>
      <button data-testid="waitlist-submit" type="submit" disabled={busy} className="w-full btn-gold rounded-full h-10 text-sm font-semibold disabled:opacity-60">Join waitlist</button>
    </form>
  );
}
